export default __webpack_public_path__ + "static/media/popularBrands.95e62269.png";